import { createApp } from "vue";
import { mypageChatVApp } from "./chat";
export const initMyPageChat = () => {
    const app = document.getElementById("mypage-chat-app");
    if (app == null) {
        return;
    }
    // bladeファイルからjsに連携しないといけないデータが存在しない場合、初期化しない
    const jsIntegration = JSON.parse(document.querySelector("#js-integration")?.innerHTML || "{}");
    if (Object.keys(jsIntegration).length !== 0) {
        createApp(mypageChatVApp).mount("#mypage-chat-app");
    }
};
